import styled from 'styled-components';

const StyledToggleContainer = styled.div`
  min-width: 110px;
  align-content: center;
`;

export { StyledToggleContainer };
